import { createSvgIcon } from '@automata/mui-theme';

export const rocketIcon = createSvgIcon(
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0001 43.9999C8.00008 47.3599 6.66675 57.3332 6.66675 57.3332C6.66675 57.3332 16.6401 55.9999 20.0001 51.9999C21.8934 49.7599 21.8667 46.3199 19.7601 44.2399C18.7236 43.2506 17.3582 42.6789 15.926 42.6346C14.4938 42.5903 13.0958 43.0765 12.0001 43.9999Z"
      stroke="#2B7FFF"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 40.0003L24 32.0003C25.4191 28.3188 27.2059 24.7898 29.3333 21.467C32.4405 16.499 36.767 12.4085 41.9013 9.58458C47.0357 6.76069 52.8071 5.29732 58.6667 5.33367C58.6667 12.587 56.5867 25.3337 42.6667 34.667C39.2984 36.7969 35.7249 38.5837 32 40.0003Z"
      stroke="#2B7FFF"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.0001 32.0004H10.6667C10.6667 32.0004 12.1334 23.9204 16.0001 21.3337C20.3201 18.4537 29.3334 21.3337 29.3334 21.3337"
      stroke="#2B7FFF"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 40.0003V53.3337C32 53.3337 40.08 51.867 42.6667 48.0003C45.5467 43.6803 42.6667 34.667 42.6667 34.667"
      stroke="#2B7FFF"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'rocketIcon'
);
